export default __webpack_public_path__ + "static/media/02-2.b5b62823.jpg";